module.exports = __webpack_public_path__ + "static/media/ci-sin-chip.f9bc79e3.jpg";